import { CourseProgram, NanodegreeProgram, PartProgram, Program } from '../models/program';

export function isNanodegreeProgram(program: Program): program is NanodegreeProgram {
  return program && 'semanticType' in program && program.semanticType === 'Degree';
}

export function isPartProgram(program: Program): program is PartProgram {
  return program && 'semanticType' in program && program.semanticType === 'Part';
}

export function isCourseProgram(program: Program): program is CourseProgram {
  return program && 'semanticType' in program && program.semanticType === 'Course';
}
